import ListPage from "../../components/Page/listPage";
import { Modal } from "antd";
import { useState, useEffect } from "react";
import CircularProgress from "../../components/CircularProgress";
import FactorDetail from "../../components/FactorDetail";
import { ReadNewCustomer } from "../../API/addCustomers";
import NewCustommerDetails from "../../components/NewCustommerDetail";

const ErrorModal = Modal.error;
const DetailModal = Modal.info;

export default function AddCustomer() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  function findData(){
    setLoading(true);
    ReadNewCustomer()
      .then((i) => {
        if (i.success) {
          setData(i.data);
        } else {
          ErrorModal({
            title: "خطا",
            content: "مشکلی هنگان انجام عمیلات رخداد",
            okText: "باشد",
            okType: "danger",
            onOk() {},
          });
        }
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((i) => {
        ErrorModal({
          title: "خطا",
          content: "مشکلی هنگان انجام عمیلات رخداد" + i,
          okText: "باشد",
          okType: "danger",
          onOk() {},
        });
      });
  }

  useEffect(() => {
    findData();
  }, []);

  const columns = [
    {
      title: "بازاریاب",
      dataIndex: "visitorName",
      key: "visitorName",
      search: true,
    },
    {
      title: "مشتری",
      dataIndex: "customer",
      key: "customer",
      search: true,
    },
    {
      title: "جزئیات",
      dataIndex: "details",
      key: "details",
      render: (text, record) => (
        <span>
          <span
            className="gx-link"
            onClick={() => {
              DetailModal({title:record.visitorName,
                content:<><NewCustommerDetails visitor={record.visitor}/></>,
                okText:"تایید"
              })
              
            }}
          >
            جزئیات
          </span>
        </span>
      ),
    },
  ];

  const tableTitles = ["مشتری", "شماره فاکتور", "تاریخ", "توضیحات", "تخفیف"];

  return (
    <>
      {loading && <CircularProgress />}
      {!loading && (
        <ListPage
          columns={columns}
          data={data}
          tableTitles={tableTitles}
          pagsize={15}
          reloader={findData}
        />
      )}
    </>
  );
}
